import { Plugin } from './Plugin';
import { EntityPlugin } from './EntityPlugin';
import { ScenePlugin } from './ScenePlugin';
import { VSMShadowMap, PCFSoftShadowMap, SpotLight, Box3, RGBADepthPacking, MeshDepthMaterial } from 'three';

export class SpotLightShadowsPlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.dependencies.add(EntityPlugin);
		this.dependencies.add(ScenePlugin);

		const renderer = this.viewer.rendering.renderer;

		renderer.shadowMap.enabled = true;
		renderer.shadowMap.type = PCFSoftShadowMap;


		this.light = new SpotLight(0xffffff, 2.8, 10);
		this.light.castShadow = true;
		this.light.shadow.mapSize.width = 512; // default
		this.light.shadow.mapSize.height = 512; // default
		this.light.shadow.camera.near = 0.15; // default
		this.light.shadow.camera.far = 20; // default

		this.light.angle 			= 1.85;
		this.light.penumbra 		= 0.17;
		this.light.shadow.bias 		= -0.004;
		this.light.shadow.radius 	= 3;

		this.viewer.rendering.scene.add(this.light);
	}

	attach(){
		this.manager.get(ScenePlugin).on('scene-changed', this.onSceneUpdate);
		this.manager.get(ScenePlugin).on('scene-updated', this.onSceneUpdate);
	}

	detach(){
		this.manager.get(ScenePlugin).off('scene-changed', this.onSceneUpdate);
		this.manager.get(ScenePlugin).off('scene-updated', this.onSceneUpdate);
	}


	onSceneUpdate = (scene) => {
		const box = new Box3().setFromObject(scene);
		box.getCenter(this.light.position);
		this.light.position.y = box.max.y;
	}

}